import { AutogenLayoutCommissionableMarginQuickInfo } from "./autogen/AutogenLayoutCommissionableMarginQuickInfo";

export class CommissionableMarginQuickInfo extends AutogenLayoutCommissionableMarginQuickInfo {
}
